module.exports = __webpack_public_path__ + "img/bg1.821499d0.png";